import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IAccountAuditParams, IAccountAuditResponse } from '@mavles/accounts';
import { IDashboardData } from '@models/dashboard/dashboard';
import { SalesDashboardResponse } from '@models/dashboard/sales-dashboard';
import { SupervisorDashboardResponse } from '@models/dashboard/supervisor-dashboard';
import { IDashboardOverviewData, IDashboardOverviewParams } from '@models/dashboard/overview-dashboard';
import { HTTPResponse, APP_CONFIG } from '@mavles/shared';

@Injectable({
  providedIn: 'root'
})
export class DashboardApiService {
  private http = inject(HttpClient);
  private appConfig = inject(APP_CONFIG);

  private readonly homeAPI = this.appConfig.apiUrl + 'dashboard/home';
  private readonly overviewAPI = this.appConfig.apiUrl + 'dashboard/overview';
  private readonly auditAPI = this.appConfig.apiUrl + 'accounts/reports/audit';
  private readonly salesDashboardAPI = this.appConfig.apiUrl + 'dashboard/sales';
  private readonly supervisorDashboardAPI = this.appConfig.apiUrl + 'dashboard/supervisor';

  dashData!:IDashboardData;

  getOverviewDashboard(params?: IDashboardOverviewParams): Observable<HTTPResponse<IDashboardOverviewData>> {
    let httpParams = new HttpParams();
    if (params?.preset) {
      httpParams = httpParams.set('preset', params.preset);
    }
    if (params?.start_date) {
      httpParams = httpParams.set('start_date', params.start_date);
    }
    if (params?.end_date) {
      httpParams = httpParams.set('end_date', params.end_date);
    }
    return this.http.get<HTTPResponse<IDashboardOverviewData>>(this.overviewAPI, { params: httpParams });
  }

  getAllHomeItems(): Observable<HTTPResponse<IDashboardData>> {
    return this.http.get<HTTPResponse<IDashboardData>>(this.homeAPI);
  }

  getAccountsAudit(params: IAccountAuditParams): Observable<HTTPResponse<IAccountAuditResponse>> {
    let httpParams = new HttpParams();

    const contactType = params.contact_type || 'customer';
    httpParams = httpParams.append('contact_type', contactType);

    if (params.start_date) httpParams = httpParams.append('start_date', params.start_date);
    if (params.end_date) httpParams = httpParams.append('end_date', params.end_date);
    if (params.account_status !== undefined && params.account_status !== null) {
      httpParams = httpParams.append('account_status', params.account_status.toString());
    }
    if (params.page) httpParams = httpParams.append('page', params.page.toString());
    if (params.per_page) httpParams = httpParams.append('per_page', params.per_page.toString());
    if (params.sort_by) httpParams = httpParams.append('sort_by', params.sort_by);
    if (params.sort_order) httpParams = httpParams.append('sort_order', params.sort_order);
    if (params.contact_name) httpParams = httpParams.append('contact_name', params.contact_name);
    if (params.closure_status) httpParams = httpParams.append('closure_status', params.closure_status);

    return this.http.get<HTTPResponse<IAccountAuditResponse>>(this.auditAPI, { params: httpParams });
  }

  getDashboard(year: number, period?: string, quarter?: number, month?: number): Observable<SalesDashboardResponse> {
    let params = new HttpParams().set('year', year.toString());
    
    if (period && period !== 'year') {
      params = params.set('period', period);
      if (period === 'quarter' && quarter) {
        params = params.set('quarter', quarter.toString());
      }
      if (period === 'month' && month) {
        params = params.set('month', month.toString());
      }
    }
    
    return this.http.get<SalesDashboardResponse>(this.salesDashboardAPI, { params });
  }

  getSupervisorDashboard(year: number): Observable<SupervisorDashboardResponse> {
    const params = new HttpParams().set('year', year.toString());
    return this.http.get<SupervisorDashboardResponse>(this.supervisorDashboardAPI, { params });
  }
}
